import ActiveLineScrollAnimationModule from './ActiveLineScrollAnimationModule';

export default ActiveLineScrollAnimationModule;
